@defer (when loading()) {
    <section class="timeline-items scroll-section">
        @for (item of timeline; track $index) {
            @if (isScheduleEntry(item.item_type, item.card_type)) {
                <app-timeline-schedule-entry [timeline_item]="item" class="scheduled-entry"> </app-timeline-schedule-entry>
            }

            @if (isCard(item.item_type, item.card_type) && ensureData(item) && !['fan_stream_post', 'trivia'].includes(item.card_type)) {
                <app-timeline-card
                    [style.backgroundImage]="handleBackground(item)"
                    [timeline_item]="item"
                    class="bleachr-card"
                    [class]="item.card_type"
                    [timeline_id]="timeline_id"
                ></app-timeline-card>
            }

            @if (isComponent(item.item_type, item.card_type) && ensureData(item)) {
                <app-timeline-component [timeline_item]="item" [timeline_id]="timeline_id"></app-timeline-component>
            }
        }
    </section>
} @placeholder {
    <app-loading-indicator></app-loading-indicator>
}
